import { render } from "./WorkflowsBtn.vue?vue&type=template&id=cb8cbfcc&scoped=true"
import script from "./WorkflowsBtn.vue?vue&type=script&lang=js"
export * from "./WorkflowsBtn.vue?vue&type=script&lang=js"

import "./WorkflowsBtn.vue?vue&type=style&index=0&id=cb8cbfcc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb8cbfcc"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QTooltip});
